import { render, staticRenderFns } from "./InformationType.vue?vue&type=template&id=5acb4355&"
import script from "./InformationType.vue?vue&type=script&lang=ts&"
export * from "./InformationType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports